import $ from 'jquery/dist/jquery.min'

function openModal(modalID) {
  $(`#${modalID}`).css('display', 'block');
  
  setTimeout(() => {
    $(`#${modalID}`).addClass('open');
  }, 250);
}

// Close the Modal
function closeModal() {
  $(".js_slideshow").removeClass('open');

  setTimeout(() => {
    $(".js_slideshow").css('display', 'none');
  }, 500);
  
}

var slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = $(".js_slideshow_slide");
  if (slides.length > 0){
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slides[slideIndex-1].style.display = "flex";
  }
}

if ( $('.js_slideshow').length > 0 ) {
  $('.js_open_slideshow').on('click', function (e) {
    e.preventDefault();
    const $modalID = $(this).data('modal');
    openModal($modalID);
    currentSlide(1);
    $('body').css('overflow', 'hidden');
  });

  $('.js_close_slideshow').on('click', function () {
    closeModal();
    $('body').css('overflow', 'auto');
  });

  $('.js_slideshow_prev').on('click', function () {
    plusSlides(-1)
  });

  $('.js_slideshow_next').on('click', function () {
    plusSlides(1)
  });
}




// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/Lightbox.jsx